import { createAction, props } from '@ngrx/store';
import { Moment } from 'moment';

import { Snapshot, Vdd, VddWithContent } from '@vi-iot/client';

import {
  RemoteDiagnosticsControlUnit,
  RemoteDiagnosticsVddListParameter,
} from '../remote-diagnostics';

import { SnapshotType } from './remote-diagnostics-snapshots.model';

export namespace RemoteDiagnosticsSnapshotsActions {
  export enum Type {
    FETCH_SNAPSHOTS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Snapshots',
    FETCH_SNAPSHOTS_RESPONSE = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Snapshots Response',
    FETCH_SNAPSHOTS_SUCCESS = '[FETCH SNAPSHOTS SNAPSHOTS] Fetch Snapshots Success',
    FETCH_SNAPSHOTS_FAILED = '[FETCH SNAPSHOTS SNAPSHOTS] Fetch Snapshots Failed',

    FETCH_SNAPSHOT_DETAILS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Snapshot Details',
    FETCH_SNAPSHOT_DETAILS_SUCCESS = '[FETCH SNAPSHOTS SNAPSHOTS] Fetch Snapshot Details Success',
    FETCH_SNAPSHOT_DETAILS_FAILED = '[FETCH SNAPSHOTS SNAPSHOTS] Fetch Snapshot Details Failed',

    SET_INSTALLATION_VDD_LIST = '[REMOTE DIAGNOSTICS SNAPSHOTS] Set Installation VDD list',
    FETCH_INSTALLATION_VDD_LIST = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Installation VDD list',
    FETCH_INSTALLATION_VDD_LIST_SUCCESS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Installation VDD List Success',
    FETCH_INSTALLATION_VDD_LIST_FAILED = '[REMOTE DIAGNOSTICS SNAPSHOTS] Fetch Installation VDD List Failed',

    CREATE_SNAPSHOT_OF_TYPE_BACKUP = '[REMOTE DIAGNOSTICS SNAPSHOTS] Create Snapshot of type backup',
    CREATE_SNAPSHOT_OF_TYPE_SNAPSHOT = '[REMOTE DIAGNOSTICS SNAPSHOTS] Create Snapshot of type snapshot',
    CREATE_SNAPSHOT_SUCCESS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Create Snapshot Success',
    CREATE_SNAPSHOT_FAILED = '[REMOTE DIAGNOSTICS SNAPSHOTS] Create Snapshot Failed',

    UPDATE_SNAPSHOT_WITH_VDD_CONTENT = '[REMOTE DIAGNOSTICS SNAPSHOTS] Update Snapshot With VDD Content',
    UPDATE_SNAPSHOT_WITH_VDD_CONTENT_SUCCESS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Update Snapshot With VDD Content Success',
    UPDATE_SNAPSHOT_WITH_VDD_CONTENT_FAILED = '[REMOTE DIAGNOSTICS SNAPSHOTS] Update Snapshot With VDD Content Failed',

    CANCEL_SNAPSHOT_VDD = '[REMOTE DIAGNOSTICS SNAPSHOTS] Cancel Snapshot VDD',
    CANCEL_SNAPSHOT_VDD_SUCCESS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Cancel Snapshot VDD Success',
    CANCEL_SNAPSHOT_VDD_FAILED = '[REMOTE DIAGNOSTICS SNAPSHOTS] Cancel Snapshot VDD Failed',

    SET_CURRENT_READING_SNAPSHOT_VALUES_STEP = '[REMOTE DIAGNOSTICS SNAPSHOTS] Set Current Reading Snapshot Values Step',
    SNAPSHOT_SELECTED = '[REMOTE DIAGNOSTICS SNAPSHOTS] Snapshot Selected',

    READ_VDD_LIST_VALUES_FOR_SNAPSHOT = '[REMOTE DIAGNOSTICS SNAPSHOTS] Read vdd list values for snapshot',
    SET_DATE_OF_THE_VALUES_READ = '[REMOTE DIAGNOSTICS SNAPSHOTS] Set date of the values read',
    CLEAR_DATE_OF_THE_VALUES_READ = '[REMOTE DIAGNOSTICS SNAPSHOTS] Clear date of the values read',

    SHOW_VALUES = '[REMOTE DIAGNOSTICS SNAPSHOTS] Show values',
    HIDE_VALUES = '[REMOTE DIAGNOSTICS SNAPSHOTS] Hide values',

    SHOW_MORE_SNAPSHOTS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Show more snapshots',
    SHOW_LESS_SNAPSHOTS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Show less snapshots',
    SET_FITLER_DATE = '[REMOTE DIAGNOSTICS SNAPSHOTS] Set filter date',

    ADD_PARAMETER = '[REMOTE DIAGNOSTICS SNAPSHOTS] Add parameter',
    DELETE_PARAMETER = '[REMOTE DIAGNOSTICS SNAPSHOTS] Delete parameter',
    DELETE_ALL_PARAMETERS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Delete all parameters',

    SELECT_CONTROL_UNIT = '[REMOTE DIAGNOSTICS SNAPSHOTS] Select control unit',

    LOAD_VDD_LIST_SUCCESS = '[REMOTE DIAGNOSTICS SNAPSHOTS] Load vdd list success',

    CLEAR_STATE = '[REMOTE DIAGNOSTICS SNAPSHOTS] Clear State',
  }

  export const fetchSnapshots = createAction(
    Type.FETCH_SNAPSHOTS,
    props<{
      installationId: number;
      snapshotType: SnapshotType;
      wasBackupGenerated: boolean;
    }>()
  );

  export const fetchSnapshotsResponse = createAction(
    Type.FETCH_SNAPSHOTS_RESPONSE,
    props<{
      snapshots?: Snapshot[];
      error?: any;
    }>()
  );

  export const fetchSnapshotsSuccess = createAction(
    Type.FETCH_SNAPSHOTS_SUCCESS,
    props<{
      snapshots: Snapshot[];
    }>()
  );

  export const fetchSnapshotsFailed = createAction(
    Type.FETCH_SNAPSHOTS_FAILED,
    props<{
      error: any;
    }>()
  );

  export const fetchSnapshotDetails = createAction(
    Type.FETCH_SNAPSHOT_DETAILS,
    props<{
      installationId: number;
      snapshotId: string;
    }>()
  );

  export const fetchSnapshotDetailsSuccess = createAction(
    Type.FETCH_SNAPSHOT_DETAILS_SUCCESS,
    props<{
      snapshotDetails: VddWithContent[];
    }>()
  );

  export const fetchSnapshotDetailsFailed = createAction(
    Type.FETCH_SNAPSHOT_DETAILS_FAILED,
    props<{
      error: any;
    }>()
  );

  export const fetchInstallationVDDList = createAction(
    Type.FETCH_INSTALLATION_VDD_LIST,
    props<{
      installationId: number;
    }>()
  );

  export const fetchInstallationVDDListSuccess = createAction(
    Type.FETCH_INSTALLATION_VDD_LIST_SUCCESS,
    props<{
      vddList: Vdd[];
    }>()
  );

  export const fetchInstallationVDDListFailed = createAction(
    Type.FETCH_INSTALLATION_VDD_LIST_FAILED
  );

  export const setInstallationVDDList = createAction(
    Type.SET_INSTALLATION_VDD_LIST,
    props<{
      vddList: Vdd[];
    }>()
  );

  export const createSnapshotOfTypeBackup = createAction(
    Type.CREATE_SNAPSHOT_OF_TYPE_BACKUP,
    props<{
      installationId: number;
      snapshotType: SnapshotType;
    }>()
  );

  export const createSnapshotOfTypeSnapshot = createAction(
    Type.CREATE_SNAPSHOT_OF_TYPE_SNAPSHOT,
    props<{
      installationId: number;
      snapshotType: SnapshotType;
    }>()
  );

  export const createSnapshotSuccess = createAction(
    Type.CREATE_SNAPSHOT_SUCCESS,
    props<{
      snapshot: Snapshot;
      installationId: number;
      snapshotType: SnapshotType;
    }>()
  );

  export const createSnapshotFailed = createAction(
    Type.CREATE_SNAPSHOT_FAILED,
    props<{
      error: any;
    }>()
  );

  export const updateSnapshotWithVddContent = createAction(
    Type.UPDATE_SNAPSHOT_WITH_VDD_CONTENT,
    props<{
      snapshotId: string;
      installationId: number;
      snapshotType: SnapshotType;
    }>()
  );

  export const updateSnapshotWithVddContentSuccess = createAction(
    Type.UPDATE_SNAPSHOT_WITH_VDD_CONTENT_SUCCESS,
    props<{
      snapshotId: string;
      installationId: number;
    }>()
  );

  export const updateSnapshotWithVddContentFailed = createAction(
    Type.UPDATE_SNAPSHOT_WITH_VDD_CONTENT_FAILED,
    props<{
      error: any;
    }>()
  );

  export const cancelSnapshotVdd = createAction(
    Type.CANCEL_SNAPSHOT_VDD,
    props<{
      installationId: number;
      snapshotId: string;
    }>()
  );

  export const cancelSnapshotVddSuccess = createAction(
    Type.CANCEL_SNAPSHOT_VDD_SUCCESS,
    props<{
      installationId: number;
      snapshotId: string;
    }>()
  );

  export const cancelSnapshotVddFailed = createAction(
    Type.CANCEL_SNAPSHOT_VDD_FAILED,
    props<{
      error: any;
    }>()
  );

  export const snapshotSelected = createAction(
    Type.SNAPSHOT_SELECTED,
    props<{
      snapshot: Snapshot | null;
    }>()
  );

  export const triggerReadVddListValuesForSnapshot = createAction(
    Type.READ_VDD_LIST_VALUES_FOR_SNAPSHOT,
    props<{
      gatewaySerial: string;
      vdd?: Vdd;
    }>()
  );

  export const addParameter = createAction(Type.ADD_PARAMETER, props<{ vdd: Vdd }>());

  export const selectControlUnit = createAction(
    Type.SELECT_CONTROL_UNIT,
    props<{ controlUnit: RemoteDiagnosticsControlUnit }>()
  );

  export const loadVddListSuccess = createAction(
    Type.LOAD_VDD_LIST_SUCCESS,

    props<{
      gatewaySerial: string;
      parameters: RemoteDiagnosticsVddListParameter[];
    }>()
  );

  export const deleteParameter = createAction(
    Type.DELETE_PARAMETER,

    props<{ vdd: Vdd }>()
  );

  export const deleteAllParameters = createAction(Type.DELETE_ALL_PARAMETERS);

  export const setDateOfTheValuesRead = createAction(Type.SET_DATE_OF_THE_VALUES_READ);

  export const clearDateOfTheValuesRead = createAction(Type.CLEAR_DATE_OF_THE_VALUES_READ);

  export const showValues = createAction(Type.SHOW_VALUES);

  export const hideValues = createAction(Type.HIDE_VALUES);

  export const showMoreSnapshots = createAction(Type.SHOW_MORE_SNAPSHOTS);

  export const showLessSnapshots = createAction(Type.SHOW_LESS_SNAPSHOTS);

  export const setFilterDate = createAction(
    Type.SET_FITLER_DATE,
    props<{
      date: Moment;
    }>()
  );

  export const clearState = createAction(Type.CLEAR_STATE);
}
